import React, { ReactNode } from "react";
import Flex from "../../core/Flex";
import { screenerStyles } from "../careScreenerStyles";
import { css } from "aphrodite";
import { insuranceStyles } from "./insuranceStyles";
import CreateYourAccount from "./CreateYourAccount";
import mooshooCheck from "../../../assets/care-screener/mooshoo-check.png";

type Props = {
  progressComponent: ReactNode;
  onPasswordSubmitted: (value: string | undefined) => Promise<void>;
  consultPath: string;
};

export default function InsuranceUnknownCoverage({ progressComponent, onPasswordSubmitted, consultPath }: Props) {
  return (
    <Flex className={css(screenerStyles.whiteContainerRoundedEdges, screenerStyles.padding, screenerStyles.container)}>
      {progressComponent}
      <Flex flexGrow center>
        <div className={css(insuranceStyles.verticalSpacer)} />
        <img src={mooshooCheck} />
        <p className={css(insuranceStyles.title)}>You're likely covered, but we need to check manually!</p>
        <div className={css(insuranceStyles.verticalSpacer)} />
        <CreateYourAccount
          subttitleText="to connect with our billing team & book your session!"
          showNextLine={true}
          onPasswordSubmitted={onPasswordSubmitted}
          consultPath={consultPath}
        />
      </Flex>
    </Flex>
  );
}
